import { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import StatusChip from "../../../component/ui/chip/status";
import Style from "./style.module.css";

export default function DragCarousel() {
  const sliderRef = useRef(null);
  const thumbRef = useRef(null);
  const pos = useRef({ left: 0, x: 0, isDown: false });

//   useEffect(() => {
//     const slider = sliderRef.current;

//     const mouseDownHandler = (e) => {
//       pos.current.isDown = true;
//       slider.classList.add("grabbing");
//       pos.current.x = e.pageX - slider.offsetLeft;
//       pos.current.left = slider.scrollLeft;
//     };

//     const mouseMoveHandler = (e) => {
//       if (!pos.current.isDown) return;
//       e.preventDefault();
//       const dx = e.pageX - slider.offsetLeft - pos.current.x;
//       slider.scrollTo({
//         left: pos.current.left - dx,
//         behavior: "auto",
//       });
//     };

//     const mouseUpHandler = () => {
//       pos.current.isDown = false;
//       slider.classList.remove("grabbing");
//     };

//     // TOUCH HANDLERS — same logic
//     const touchStart = (e) => {
//       pos.current.isDown = true;
//       pos.current.x = e.touches[0].pageX - slider.offsetLeft;
//       pos.current.left = slider.scrollLeft;
//     };

//     const touchMove = (e) => {
//       if (!pos.current.isDown) return;
//       const dx = e.touches[0].pageX - slider.offsetLeft - pos.current.x;
//       slider.scrollTo({
//         left: pos.current.left - dx,
//         behavior: "auto",
//       });
//     };

//     const touchEnd = () => {
//       pos.current.isDown = false;
//     };

//     slider.addEventListener("mousedown", mouseDownHandler);
//     slider.addEventListener("mousemove", mouseMoveHandler);
//     slider.addEventListener("mouseup", mouseUpHandler);
//     slider.addEventListener("mouseleave", mouseUpHandler);

//     slider.addEventListener("touchstart", touchStart, { passive: true });
//     slider.addEventListener("touchmove", touchMove, { passive: true });
//     slider.addEventListener("touchend", touchEnd);

//     return () => {
//       slider.removeEventListener("mousedown", mouseDownHandler);
//       slider.removeEventListener("mousemove", mouseMoveHandler);
//       slider.removeEventListener("mouseup", mouseUpHandler);
//       slider.removeEventListener("mouseleave", mouseUpHandler);

//       slider.removeEventListener("touchstart", touchStart);
//       slider.removeEventListener("touchmove", touchMove);
//       slider.removeEventListener("touchend", touchEnd);
//     };
//   }, []);

  /// arrows code

 useEffect(() => {
  const slider = sliderRef.current;
  if (!slider) return;

  // Ensure no native smooth scrolling interferes
  slider.style.scrollBehavior = "auto";

  let isDown = false;
  let startX = 0;
  let startScroll = 0;
  let lastX = 0;
  let lastTime = 0;
  let velocity = 0;
  let rafId = null;

  // Inertia loop
  const runInertia = () => {
    // apply velocity (px per frame)
    if (Math.abs(velocity) < 0.02) {
      velocity = 0;
      cancelAnimationFrame(rafId);
      rafId = null;
      return;
    }

    slider.scrollLeft -= velocity;
    // friction - tune between 0.90 and 0.98
    velocity *= 0.94;
    rafId = requestAnimationFrame(runInertia);
  };

  // Pointer handlers (works for mouse + touch)
  const onPointerDown = (e) => {
    // only left mouse button or touch
    if (e.pointerType === "mouse" && e.button !== 0) return;

    isDown = true;
    slider.setPointerCapture?.(e.pointerId);
    slider.classList.add("grabbing");

    startX = e.clientX;
    startScroll = slider.scrollLeft;
    lastX = e.clientX;
    lastTime = e.timeStamp;
    velocity = 0;

    // stop any running inertia
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  const onPointerMove = (e) => {
    if (!isDown) return;
    e.preventDefault(); // prevent text selection / default scrolling
    const x = e.clientX;
    const dx = x - startX;
    const newScroll = startScroll - dx;
    slider.scrollLeft = newScroll;

    // compute instantaneous velocity (px per ms)
    const dt = Math.max(1, e.timeStamp - lastTime);
    const dxSince = x - lastX;
    const instV = dxSince / dt; // px per ms

    // low-pass filter to smooth velocity measurement
    velocity = instV * 0.3 + velocity * 0.7; // tune smoothing

    lastX = x;
    lastTime = e.timeStamp;
  };

  const onPointerUp = (e) => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove("grabbing");
    slider.releasePointerCapture?.(e.pointerId);

    // Convert velocity (px/ms) to px/frame approx
    // multiply by ~16ms to get px/frame estimate, then scale factor
    velocity = (velocity * 16) * 1.6; // tune multiplier (1.0-2.0) for stronger inertia

    // kick off inertia if velocity present
    if (Math.abs(velocity) > 0.5) {
      rafId = requestAnimationFrame(runInertia);
    } else {
      velocity = 0;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }
  };

  // Attach pointer listeners
  slider.addEventListener("pointerdown", onPointerDown, { passive: false });
  window.addEventListener("pointermove", onPointerMove, { passive: false });
  window.addEventListener("pointerup", onPointerUp);

  // cleanup
  return () => {
    slider.removeEventListener("pointerdown", onPointerDown);
    window.removeEventListener("pointermove", onPointerMove);
    window.removeEventListener("pointerup", onPointerUp);
    if (rafId) cancelAnimationFrame(rafId);
  };
}, []);





  //  Arrow Section
  const scrollRight = () => {
    const slider = sliderRef.current;
    const amount = slider.clientWidth / 1.2; // scroll by ~1 card
    slider.scrollBy({ left: amount, behavior: "smooth" });
  };

  const scrollLeft = () => {
    const slider = sliderRef.current;
    const amount = slider.clientWidth / 1.2;
    slider.scrollBy({ left: -amount, behavior: "smooth" });
  };

  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);

  const updateThumbPosition = () => {
    const slider = sliderRef.current;
    const thumb = thumbRef.current;

    if (!slider || !thumb) return;

    const visibleWidth = slider.clientWidth;
    const totalWidth = slider.scrollWidth;

    // thumb size (proportion of visible area)
    const thumbWidth = (visibleWidth / totalWidth) * visibleWidth;

    // current position ratio
    const scrollRatio = slider.scrollLeft / (totalWidth - visibleWidth);

    // position of thumb
    const thumbLeft = scrollRatio * (visibleWidth - thumbWidth);

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.left = `${thumbLeft}px`;
  };

  useEffect(() => {
    updateThumbPosition();
  }, []);

  const handleScroll = () => {
    const slider = sliderRef.current;

    setShowLeft(slider.scrollLeft > 10);
    setShowRight(
      slider.scrollLeft < slider.scrollWidth - slider.clientWidth - 10
    );

    updateThumbPosition();
  };

  return (
    <div className="relative w-full  h-full  flex it ems-center">
      {/* LEFT ARROW */}

      {showLeft && (
        <button
          className="absolute left-0 top-1/2 -translate-y-1/2 z-20 
               bg-white shadow rounded-full p-2 
               hover:bg-gray-100 transition"
          onClick={scrollLeft}
        >
          <ChevronLeft size={20} />
        </button>
      )}

      {/* RIGHT ARROW */}

      {showRight && (
        <button
          className="absolute right-0 top-1/2 -translate-y-1/2 z-20 
               bg-white shadow rounded-full p-2 
               hover:bg-gray-100 transition"
          onClick={scrollRight}
        >
          <ChevronRight size={20} />
        </button>
      )}

      <div
        ref={sliderRef}
        onScroll={handleScroll}
        className={`
        ${Style.dragWrapper}
      flex overflow-x-scroll select-none
      cursor-grab active:cursor-grabbing
      items-center h-full gap-4 no-scrollbar
      p-1
        `}
        // style={{ scrollBehavior: "smooth" }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            //   className="min-w-[280px] md:min-w-[320px]"
            className="min-w-[calc(25%-12px)] max-w-[calc(25%-12px)]"
          >
            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="flex p-4 rounded-lg border border-[#E1E4EA] shadow !hover:shadow-xl bg-white transition-all duration-300"
            >
              <div className="w-full flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <h4 className="text-sm text-gray-500">Project</h4>
                  <div className="text-lg font-semibold">Test</div>
                </div>

                <div className="flex flex-col">
                  <div className="flex justify-between items-center py-2">
                    <span className="text-sm text-gray-600">Status</span>
                    <span className="py-1 px-3 rounded-2xl text-white text-xs bg-blue-600">
                      20 Tasks
                    </span>
                  </div>

                  <div className="py-[10px] px-[14px]  border border-[#E1E4EA] bg-[#F3F3F3] rounded-[5px] flex justify-center items-center">
                    <div className="flex flex-col items-center gap-1 w-full">
                      <span className="text-[10px] font-semibold text-gray-600">
                        In Process
                      </span>
                      <span className="text-3xl font-semibold">5</span>
                    </div>

                    <div className="w-1 bg-blue-600 h-full"></div>

                    <div className="flex flex-col items-center gap-1 w-full">
                      <span className="text-[10px] font-semibold text-gray-600">
                        Completed
                      </span>
                      <span className="text-3xl font-semibold">12</span>
                    </div>
                  </div>
                </div>

                <div>
                  <p className="text-sm font-medium text-gray-600">
                    Project Details:
                  </p>
                  <div className="flex gap-1 mt-1 text-sm font-medium">
                    <p>Peter Parker</p>
                    <p className="border-l-2 pl-2">PPC Team</p>
                  </div>

                  <div className="flex justify-between items-center py-2">
                    <StatusChip color="blue">Pending</StatusChip>

                    <button className="group flex items-center gap-1">
                      <span className="underline text-sm font-semibold">
                        See Details
                      </span>
                      <ChevronRight className="group-hover:translate-x-1 transition" />
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
}
